var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconClassInfoFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Selected Icon",
    clipPath: "url(#clip0_0_86)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7ZM6.85417 4.66667C7.25687 4.66667 7.58333 4.34021 7.58333 3.9375C7.58333 3.53479 7.25687 3.20833 6.85417 3.20833C6.45146 3.20833 6.125 3.53479 6.125 3.9375C6.125 4.34021 6.45146 4.66667 6.85417 4.66667ZM6.41667 5.39583C6.17504 5.39583 5.97917 5.59171 5.97917 5.83333C5.97917 6.07496 6.17504 6.27083 6.41667 6.27083H6.5625V9.625H5.83333C5.59171 9.625 5.39583 9.82088 5.39583 10.0625C5.39583 10.3041 5.59171 10.5 5.83333 10.5H7H8.16667C8.40829 10.5 8.60417 10.3041 8.60417 10.0625C8.60417 9.82088 8.40829 9.625 8.16667 9.625H7.4375V5.83333C7.4375 5.59171 7.24162 5.39583 7 5.39583H6.41667Z",
    fill: "var(--fill-0, white)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_86"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClassInfoFilled);
export default __webpack_public_path__ + "static/media/iconClassInfoFilled.a5fac1faadfb9348548dba2cb6164d57.svg";
export { ForwardRef as ReactComponent };